/* COPYRIGHT Esri - https://js.arcgis.com/5.1/LICENSE.txt */
function getDimensionClass(type, size, scale) {
  return size ? `${type}-${size}` : scale ? `${type}-${scale}` : `${type}-m`;
}
export {
  getDimensionClass as g
};
